import react, { useState } from "react"
import { resources } from "../Resourses/Resources"
import axios from "axios"

const RegularFeeExcelUpload = () => {
    const [selectedFile, setSelectedFile] = useState([])
    const handleSelectFile = async (e) => {
        const files = e.target.files[0]
        setSelectedFile(files)
    }
    const handleReset = async () => {
        document.getElementById("feeDetailsExcel").value = ""
    }

    const handleSubmit = async () => {
        try {
            const formData = new FormData()
            formData.append("file", selectedFile)
            console.log("fileto send===>", selectedFile)
            const response = await axios.post(resources.APPLICATION_URL + `feeDetailsUploadExcelForRegular`, formData)
            console.log("response===>", response.data)
        } catch (error) {
            console.log("error==>", error)
        }
    }
    return (
        <div className="uploadExcelContainer">
            <div>
                <label>Regular Fee Details Excel File</label>
            </div>
            <div className="fileAndButtonDiv">
                <div className="fileDiv">
                    <input type="file" id="feeDetailsExcel" onChange={(e) => handleSelectFile(e)} />
                </div>
                <div className="fileButtons">
                    <button className="resetButton" onClick={() => handleReset()}>Reset</button>
                    <button className="uploadButton" onClick={() => handleSubmit()}>Upload</button>
                </div>

            </div>
            <div>
                <a className="anchorTagDownload" href={resources.APPLICATION_URL + "getFeeDetailsTemplate"}>Download Template</a>

            </div>
        </div>
    )
}
export default RegularFeeExcelUpload;